module.exports = __webpack_public_path__ + "img/refresh-code.0b2b14b0.png";